module.exports = __webpack_public_path__ + "img/admin-2017-meeting.15452ab2.jpg";